<template>
  <!-- table组件 -->
  <div ref="vTable" class="v-table">
    <el-table
      v-loading="loading"
      fit
      highlight-current-row
      v-bind="$attrs"
      :element-loading-text="$t('common.loadingEllipsis')"
      element-loading-spinner="el-icon-loading"
      :height="tableHeight"
      v-on="$listeners"
      @selection-change="selectionChange"
      @sort-change="sortChange"
    >
      <el-table-column
        v-if="isShowBox"
        type="selection"
        width="60px"
        align="center"
      ></el-table-column>
      <el-table-column
        v-for="(row, index) in tableRow"
        :key="index"
        :label="row.name"
        :type="row.type"
        :align="row.align || 'center'"
        :min-width="row.minWidth"
        :width="row.width"
        :fixed="row.fixed"
        :sortable="row.sortable"
        :prop="row.props"
        :class-name="row.hasIcon && 'pre-icon'"
      >
        <!-- 表头的单独设置 -->
        <template v-for="(item, idx) in specialRows" slot="header">
          <p v-if="item.props == row.props" :key="idx" class="item">
            <span>{{ row.name }}</span>
            <el-tooltip v-if="item.ctx" effect="light" placement="bottom" class="row-tooltip">
              <div slot="content" v-html="item.ctx"></div>
              <img src="../../assets/remark.png" alt="" />
            </el-tooltip>
          </p>
        </template>
        <!-- 特殊内容的设置 -->
        <template slot-scope="item">
          <span v-if="!(specialKeys && specialKeys.indexOf(row.props) > -1)">{{
            item.row[row.props] | emptyFilter(row.type)
          }}</span>
          <div v-for="(special, idx) in specialKeys" :key="idx">
            <div v-if="row.props == special">
              <slot :name="special" :data="item.row" :list="row"></slot>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'VTable',
  props: {
    tableRow: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isShowBox: {
      type: Boolean,
      default: false,
    },
    specialKeys: {
      // 特殊的td
      type: Array,
      default: () => [],
    },
    specialRows: {
      // 特殊的td带提示
      type: Array,
      default: () => [],
    },
    tHeight: {
      // 弹框中table的高度
      type: [Array, String],
      default: '',
    },
    pagination: {
      // 是否展示了分页组件
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tableHeight: 'auto',
    };
  },
  created() {
    console.log(this.pagination);
  },
  updated() {
    if (this.tHeight) {
      this.tableHeight = this.tHeight;
    } else {
      const paginationHeight = this.pagination ? 68 : 0;
      const tableHeight =
        document.body.offsetHeight -
        this.$refs.vTable.getBoundingClientRect().top - paginationHeight -20;
        // -40 是屏幕下固定一条的高度
      this.tableHeight = tableHeight < 200 ? 200 : tableHeight; // 68是分页的高度,表格最小高度改为200
    }
  },
  methods: {
    sortChange(val) {
      this.$emit('handle-order-value', val);
    },
    selectionChange(val) {
      this.$emit('handle-check', val);
    },
    selectAllRows() {
      // 全选的切换
      this.$refs.vTable.toggleAllSelection();
    },
    clearAll() {
      // 全选的清除
      this.$refs.vTable.clearSelection();
    },
  },
};
</script>

<style lang="scss">
$border: 1px solid $bottomBg;

.v-table {
  width: 100%;
  .el-table .cell,
  .item {
    line-height: 18px;
    font-size: $font12;
    color: $headerText;
  }
  .special-row {
    height: 18px;
  }
  .el-table th {
    padding: 7px 0;
    &.pre-icon {
      .cell {
        padding-left: 26px;
      }
    }
  }
  .pre-icon {
    .cell-inner-span {
      padding-left: 22px;
    }
  }
  .el-table td {
    padding: 9px 0;
  }
  .item {
    height: 18px;
    span {
      margin-right: 5px;
    }
  }
  .row-tooltip {
    width: 14px;
    position: absolute;
    top: 2px;
  }
  .el-table th.is-leaf {
    // @include tableHeaderBg;
    background: $bottomBg;
  }
  .el-table__fixed-right::before,
  .el-table__fixed::before {
    height: 0;
  }
  .el-table__fixed,
  .el-table__fixed-right {
    // box-shadow: none;
  }
  .el-table__body-wrapper {
    min-height: auto;
    // border-left: $border;
    // border-right: $border;
  }
  .el-table__header-wrapper {
    border-top: $border;
    border-right: $border;
    border-left: $border;
  }
}
</style>
